import * as React from 'react';
import { FunctionComponent } from 'react';

interface IButtonProps {
    className: string
    disabled: boolean
    onClick: () => void
}
const Button: FunctionComponent<IButtonProps> = (props) => (
    <button disabled={props.disabled} className={"button " + props.className} onClick={props.onClick}>
        {props.children}
    </button>
);

export default Button;